interface VhcBlockWrapperProps {
  groupName: string;
  children: React.ReactNode;
}

export const VhcBlockWrapper: React.FC<VhcBlockWrapperProps> = ({ groupName, children }: VhcBlockWrapperProps) => {
  return (
    <div className="p-5 d-flex flex-column gap-3 rounded  border-secondary border-dashed ">
      <h3 style={{ width: 'fit-content' }} className="fs-5 fw-bold text-secondary rounded bg-light-secondary p-3">
        {groupName}
      </h3>
      <div>{children}</div>
    </div>
  );
};
